import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import LoginForm from "./components/LoginForm";
import { grey } from "@mui/material/colors";
import ForgotPasswordForm from "./components/ForgotPasswordForm";
import { Stack } from "@mui/material";
import AuthPage from "../../Components/AuthPage";

const Login = () => {
  const [show, setShow] = useState(false);

  const handleModal = () => {
    setShow(!show);
  };

  return (
    <AuthPage title="Login" maxWidth={350}>
      <Box
        sx={{
          height: "50vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Stack direction="column" alignItems="center" spacing={6}>
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="h4" align="center" gutterBottom>
              Welcome to Digital SACCO.
            </Typography>
            <Typography sx={{ color: "text.secondary" }} align="center">
              Please Enter your details to login.
            </Typography>
          </Box>
        </Stack>

        <Box>
          <LoginForm />
        </Box>
      </Box>
    </AuthPage>
  );
};

export default Login;
